import { useContext } from 'react';
import { PrincipalAmortizationStore } from '../stores/principalAmortizationStore';
import { StoreContext } from '@roc/feature-app-core';

export const usePrincipalAmortizationStore = () =>
  useContext<{
    principalAmortizationStore: PrincipalAmortizationStore;
  }>(StoreContext);
